import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { lighten } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

interface ChooseProductCardProps {
  isChecked?: boolean;
  isDisabled: boolean;
  isInProgress?: boolean;
  for?: string;
}

export const $RowProductInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: ${spacing('xl')} ${spacing('lg')};
  @media ${media.minWidth.sm} {
    align-items: stretch;
  }
`;

export const $ColonProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${spacing('xl')} ${spacing('lg')};

  ${$RowProductInfo} {
    padding: 0;
  }
`;

interface ChooseProductCardCheckboxContainerProps {
  isChecked?: boolean;
}

export const $ChooseProductCardCheckboxContainer = styled(
  'div',
)<ChooseProductCardCheckboxContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${spacing('lg')};
  width: ${spacing(5)};
  height: ${spacing(5)};
  @media ${media.minWidth.sm} {
    width: ${spacing('xl')};
    height: ${spacing('xl')};
  }
  border-radius: ${({ theme }) => theme.tw.radius['2xl']};
  align-self: center;
  box-sizing: border-box;

  label {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: unset;
    margin: 0;
  }
`;

export const $ChooseProductCardImageContainer = styled(
  'div',
)<ChooseProductCardProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border: 1px solid ${({ theme }) => theme.colors.disabled};
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  margin-right: ${spacing('lg')};
  margin-left: ${({ isDisabled }) => (isDisabled ? spacing(10) : 'unset')};
  padding: ${spacing('xxs')};
  overflow: hidden;
  img {
    object-fit: contain;
    max-height: ${spacing(16)};
    max-width: ${spacing(16)};
  }
  @media ${media.minWidth.sm} {
    width: 70px;
    height: 70px;
  }
`;

export const $ChooseProductCardInfoContainer = styled(
  'div',
)<ChooseProductCardProps>`
  display: flex;
  flex-direction: column;
  align-self: center;
  flex: 1;
  color: ${({ theme, isDisabled }) =>
    isDisabled ? theme.colors.paragraphTextColor : theme.colors.black};
`;

export const $OpenFile = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: ${spacing('sm')};
  a,
  button {
    color: ${({ theme }) => theme.colors.mainTextColor};
    text-decoration-color: ${({ theme }) => theme.colors.black};
    text-decoration: underline;
  }
  svg {
    margin-left: ${spacing(1.5)};
    color: ${({ theme }) => theme.colors.mainTextColor};
  }
`;

export const $ChooseProductCardContainer = styled(
  'label',
)<ChooseProductCardProps>`
  position: relative;
  display: flex;
  width: 100%;
  align-items: stretch;
  justify-content: flex-start;
  background: ${({ theme, isDisabled }) => {
    if (isDisabled) {
      return theme.colors.secondaryColor2;
    }

    return theme.systemColors.defaultBackground;
  }};

  border-top: 1px solid
    ${({ theme }) => {
      return theme.colors.disabled;
    }};
  border-left: 1px solid
    ${({ theme }) => {
      return theme.colors.disabled;
    }};
  border-right: 1px solid
    ${({ theme }) => {
      return theme.colors.disabled;
    }};

  cursor: ${({ isDisabled, isInProgress }) => {
    if (isInProgress) {
      return 'progress';
    }

    if (isDisabled) {
      return 'default';
    }

    return 'pointer';
  }};

  input {
    width: 100%;
    height: 100%;
  }

  input:hover {
    ~ ${$RowProductInfo} {
      background: ${({ theme }) =>
        theme.colors.primaryHover || lighten(0.52, theme.colors.primary)};
    }
  }

  &:last-child {
    border-bottom: 1px solid
      ${({ theme }) => {
        return theme.colors.disabled;
      }};
    border-bottom-left-radius: ${({ theme }) => theme.tw.radius.lg};
    border-bottom-right-radius: ${({ theme }) => theme.tw.radius.lg};
  }
`;

export const $ModelDisplayName = styled.span`
  font-weight: bold;
`;

export const $GiftProductMessage = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing(1)};
  color: ${({ theme }) => theme.colors.success};
`;
